import TrainTypesPage from './train-types-page';

export default TrainTypesPage;